if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
      }

      get selectedOptionValues() {
        return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
          ({ dataset }) => dataset.optionValueId
        );
      }

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      connectedCallback() {
        this.addEventListener('change', (event) => {
          const target = this.getInputForEventTarget(event.target);
          this.updateSelectedSwatchValue(event);
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
            data: {
              event,
              target,
              selectedOptionValues: this.selectedOptionValues,
            },
          });
        });
      }

      /**
       * The value shown beside the option name ("Material: oak"). Every picker type renders it as
       * [data-selected-swatch-value], so update that: the previous code looked for
       * [data-selected-value], which exists only inside the swatch_dropdown branch, so querySelector
       * returned null and the label silently kept the server's value until the section render
       * replaced the whole picker.
       * @param {HTMLElement} target the input or select that changed
       * @param {string} value the newly selected option value
       */
      updateSelectedLabel(target, value) {
        const label = target.closest('.product-form__input')?.querySelector('[data-selected-swatch-value]');
        if (label) label.textContent = value;
      }

      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;

        if (tagName === 'SELECT' && target.selectedOptions.length) {
          // Optional call: a picker re-rendered without a selected attribute would otherwise throw
          // here, and everything below — including the label — would never run.
          Array.from(target.options)
            .find((option) => option.getAttribute('selected'))
            ?.removeAttribute('selected');
          target.selectedOptions[0].setAttribute('selected', 'selected');

          this.updateSelectedLabel(target, target.selectedOptions[0].value);

          const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = target
            .closest('.product-form__input')
            .querySelector('[data-selected-value] > .swatch');
          if (!selectedDropdownSwatchValue) return;
          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
            selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
          } else {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
            selectedDropdownSwatchValue.classList.add('swatch--unavailable');
          }

          selectedDropdownSwatchValue.style.setProperty(
            '--swatch-focal-point',
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
          );
        } else if (tagName === 'INPUT' && target.type === 'radio') {
          this.updateSelectedLabel(target, value);

          // GRETA (COLONNA) — lo SKU della variante è nell'attributo "sku" del radio
          // (sul tema 1.7.0 era nel value; su 2.4.0 value resta il nome opzione per la cache varianti)
          const skuToShow = target.getAttribute('sku') || value;
          gretaUpdateInstallment(skuToShow);
          gretaUpdateGallery(skuToShow);
        }
      }
    }
  );
}


// ===== GRETA — AGGIUNTO DA GIOVANNI COLONNA (portato da Sleek 1.7.0) =====

// Aggiorna rata (prezzo/3) e barcode della variante selezionata
function gretaUpdateInstallment(skuToShow) {
  document.querySelectorAll('input[type="radio"]').forEach((radio) => {
    if (radio.getAttribute('sku') !== skuToShow) return;
    const label = radio.nextElementSibling;
    if (!label) return;
    const priceElement = label.querySelector('.price');
    const barcodeElement = label.querySelector('.barcode');
    if (priceElement) {
      const price = parseFloat(priceElement.textContent.replace('€', '').replace(',', '.'));
      const installmentPrice = (price / 3).toFixed(2).replace('.', ',');
      const installmentElement = document.getElementById('installment-amount');
      if (installmentElement) installmentElement.textContent = '€' + installmentPrice;
    }
    if (barcodeElement) {
      const installmentElement2 = document.getElementById('installment-sku');
      if (installmentElement2) installmentElement2.textContent = barcodeElement.textContent;
    }
  });
}

// Galleria: mostra solo le miniature il cui file contiene lo SKU e mette la prima come immagine principale
function gretaUpdateGallery(skuToShow) {
  const mediaGallery = document.querySelector('.product__media-list');
  if (!mediaGallery || !skuToShow) return;
  const allMediaItems = mediaGallery.querySelectorAll('.product__media-item');
  const allMediaThumbs = document.querySelectorAll('.product__thumbs-item');
  let messo = 0;
  allMediaThumbs.forEach((item) => {
    const imgCheck2 = item.querySelector('img');
    if (imgCheck2 && imgCheck2.src.includes(skuToShow)) {
      item.style.display = 'block';
      const setMain = () => {
        const imgCheck3 = allMediaItems[0] && allMediaItems[0].querySelector('img');
        if (!imgCheck3) return;
        imgCheck3.src = imgCheck2.src;
        imgCheck3.srcset = [];
      };
      if (messo === 0) {
        setMain();
        messo = 1;
      }
      item.addEventListener('click', setMain);
    } else {
      item.style.display = 'none';
    }
  });
}

// Al caricamento: filtra la galleria sullo SKU della variante iniziale
(function gretaInitGallery() {
  const skuEl = document.querySelectorAll('.sku')[0];
  if (skuEl) gretaUpdateGallery(skuEl.innerHTML.trim());
})();
